/**
 * RagBadge — delivery-health pill (GREEN / AMBER / RED).
 * Uses the reserved health-* tokens via the shared `.rag-pill` shape;
 * never co-opts the system-error palette.
 */
import type { HealthRag } from '@/types/domain';

const RAG_TOKENS: Record<HealthRag, { bg: string; fg: string }> = {
  GREEN: { bg: 'var(--health-green-bg)', fg: 'var(--health-green)' },
  AMBER: { bg: 'var(--health-amber-bg)', fg: 'var(--health-amber)' },
  RED: { bg: 'var(--health-red-bg)', fg: 'var(--health-red)' },
};

interface Props {
  rag: HealthRag;
}

export function RagBadge({ rag }: Props) {
  const c = RAG_TOKENS[rag];
  return (
    <span className="rag-pill pop-in" style={{ background: c.bg, color: c.fg }}>
      <span
        aria-hidden="true"
        style={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: c.fg,
          flexShrink: 0,
        }}
      />
      {rag}
    </span>
  );
}
